var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Widget, WidgetGroup, i18n } from '@easyquery/core';
import { browserUtils } from '../utils/browser_utils';
import { AggrSettingsDialog } from "../dialog/aggr_settings_dialog";
/**
 * The widget responsed for rendering the name of the current query.
 */
var AggregationBar = /** @class */ (function (_super) {
    __extends(AggregationBar, _super);
    /**
     * The default constructor.
     * @param slot The HTML element where our widget should be placed.
     * @param customQuery The custom query
     */
    function AggregationBar(slot, customQuery) {
        var _this = _super.call(this, slot) || this;
        _this.linkClickCallback = function () {
            new AggrSettingsDialog(_this.context).show(_this.getQuery());
        };
        _this.queryEventCallbackId = null;
        _this.customQuery = customQuery;
        _this.group = WidgetGroup.Query | WidgetGroup.QueryStatus;
        return _this;
    }
    AggregationBar.prototype.init = function (context, options) {
        _super.prototype.init.call(this, context, options);
        this.destroyCore();
        this.attachQueryObserver();
    };
    Object.defineProperty(AggregationBar.prototype, "cssPrefix", {
        get: function () {
            return 'eqjs-aggrb';
        },
        enumerable: true,
        configurable: true
    });
    AggregationBar.prototype.getWidgetType = function () {
        return 'aggregationBar';
    };
    /**
     * Refresh widget implementation
     */
    AggregationBar.prototype.refreshCore = function () {
        this.render();
    };
    AggregationBar.prototype.getLinkText = function () {
        var query = this.getQuery();
        ;
        if (query.enableAggregation) {
            var aggrSettings = query.getAggregationSettings();
            var groups = aggrSettings.getInternalGroups();
            var aggrs = aggrSettings.getAggregates();
            var groupArr = [];
            var cols_1 = query.getColumns();
            for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
                var group = groups_1[_i];
                var colNames = group.columns.map(function (value) {
                    var col = cols_1.find(function (c) { return c.id == value; });
                    if (col) {
                        return col.caption;
                    }
                    else {
                        return '';
                    }
                });
                groupArr.push("[" + colNames.join(', ') + "]");
            }
            var groupString = groupArr.join(', ');
            var aggrArr = [];
            var funcs = query.getModel().getAggrFunctions();
            var _loop_1 = function (aggr) {
                var col = cols_1.find(function (c) { return c.id == aggr.colId; });
                var func = funcs.find(function (f) { return f.id == aggr.funcId; });
                if (col && func) {
                    aggrArr.push(col.caption + " (" + func.caption + ")");
                }
            };
            for (var _a = 0, aggrs_1 = aggrs; _a < aggrs_1.length; _a++) {
                var aggr = aggrs_1[_a];
                _loop_1(aggr);
            }
            var aggrString = aggrArr.join(', ');
            return (groupString || i18n.getText('AggrSettings', 'NoGroupsLabel')) + " ::: " + (aggrString ? "<" + aggrString + ">" : i18n.getText('AggrSettings', 'NoAggrsLabel'));
        }
        else {
            return i18n.getText('AggrSettings', 'EmptySettingsLabel');
        }
    };
    AggregationBar.prototype.render = function () {
        this.slot.classList.add(this.cssPrefix + "-panel");
        var mobClass = browserUtils.getMobileCssClass();
        if (mobClass) {
            this.slot.classList.add(mobClass);
        }
        if (!this.dialogLink) {
            this.dialogLink = document.createElement('a');
            this.dialogLink.setAttribute('href', 'javascript:void(0)');
            this.slot.appendChild(this.dialogLink);
        }
        // Update
        this.dialogLink.textContent = this.getLinkText();
        this.dialogLink.removeEventListener('click', this.linkClickCallback);
        this.dialogLink.addEventListener('click', this.linkClickCallback);
    };
    AggregationBar.prototype.clear = function () {
        this.slot.innerHTML = "";
        this.dialogLink = null;
    };
    AggregationBar.prototype.attachQueryObserver = function () {
        var _this = this;
        var query = this.getQuery();
        this.queryEventCallbackId = query.addChangedCallback(function (event) {
            _this.refreshCore();
        });
    };
    AggregationBar.prototype.detachQueryObserver = function () {
        if (this.queryEventCallbackId) {
            var query = this.getQuery();
            query.removeChangedCallback(this.queryEventCallbackId);
        }
    };
    AggregationBar.prototype.destroyCore = function () {
        this.clear();
        this.detachQueryObserver();
    };
    AggregationBar.prototype.getQuery = function () {
        return this.customQuery || this.context.getQuery();
    };
    return AggregationBar;
}(Widget));
export { AggregationBar };
//# sourceMappingURL=aggregation_bar.js.map